var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarningYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.033 2.122L1.308 13.634C.433 15.13 1.526 17 3.274 17h13.451c1.749 0 2.841-1.87 1.968-3.366L11.967 2.122c-.874-1.496-3.06-1.496-3.934 0z",
    stroke: "#F1E20D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.602 4.969v4.004c0 .21-.005.415-.014.616-.01.2-.021.402-.035.605l-.024.308-.028.316c-.022.212-.046.44-.074.682h-.84l-.051-.465-.051-.533-.024-.308a27.103 27.103 0 01-.035-.605c-.01-.2-.014-.406-.014-.616V4.969h1.19zM9.111 14.23a.89.89 0 01.252-.623.91.91 0 01.277-.189.844.844 0 01.346-.07c.121 0 .234.023.34.07a.91.91 0 01.465.469.85.85 0 01.07.343.844.844 0 01-.07.346.91.91 0 01-.189.277.86.86 0 01-.616.252.86.86 0 01-.875-.875z",
    fill: "#F1E20D",
    fillRule: "nonzero"
  }))));
}
export default new URL("/home/runner/work/mono/mono/ui/packages/design-system/src/assets/icon-warning-yellow.svg", import.meta.url).toString();
export { SvgIconWarningYellow as ReactComponent };